<a (click)="isMenuOpen()" class="menubtn"> <span class="bar-icon"> <span></span> <span></span> <span></span> </span>
</a> <a id="mobile_btn" class="mobile_btn" href="#sidebar"><i class="glyphicon glyphicon-menu-hamburger"></i></a>
<div class="sidebar" id="sidebar" [class.visited]="isOpen == true">
  <div class="sidebar-inner slimscroll">
    <div id="sidebar-menu" class="sidebar-menu">
      <div *ngFor="let MenuDataList of menuList; let i=index" [routerLinkActive]="['activemenu']">
        <div class="menulist" *ngIf="MenuDataList.childmenu.length==0">
          <a routerLink="/{{MenuDataList.urlpath}}" [routerLinkActive]="['activemenu']">
            <mat-icon color="accent" *ngIf="MenuDataList.description!=null" class="menu-icon">{{MenuDataList.description}}</mat-icon>
            <mat-icon color="accent" *ngIf="MenuDataList.description==null" class="menu-icon">keyboard_arrow_right</mat-icon>
            <span>{{MenuDataList.displayname}}</span>
          </a>
        </div>
        <div class="menulist dropdown-toggle" data-toggle="dropdown" *ngIf="MenuDataList.childmenu.length>0">
          <a [routerLinkActive]="['activemenu']">
            <mat-icon color="accent" *ngIf="MenuDataList.description!=null" class="menu-icon">{{MenuDataList.description}}</mat-icon>
            <mat-icon color="accent" *ngIf="MenuDataList.description==null" class="menu-icon">keyboard_arrow_right</mat-icon> 
            <span>{{MenuDataList.displayname}}</span>
          </a>
        </div>
        <div class="dropdown-menu" *ngIf="MenuDataList.childmenu.length>0">
          <a class="dropdown-item" *ngFor="let childMenu of MenuDataList.childmenu"
            routerLink="/{{childMenu.urlpath}}" [routerLinkActive]="['activemenu']">{{childMenu.displayname}}</a>
        </div>
      </div>
    </div>
  </div>
</div>
<script type="text/javascript">
  $(document).ready(function () {
    $(window).resize(function () {
      var viewportWidth = $(window).width();
      if (viewportWidth > 320) {
        $("#slide-out").removeAttr("style");
      }
    });
  })
</script>